import { render, staticRenderFns } from "./Delete_user.vue?vue&type=template&id=6b7da24d&"
import script from "./Delete_user.vue?vue&type=script&lang=js&"
export * from "./Delete_user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports